import { render, staticRenderFns } from "./druzice.vue?vue&type=template&id=4afb74a8&"
import script from "./druzice.vue?vue&type=script&lang=js&"
export * from "./druzice.vue?vue&type=script&lang=js&"
import style0 from "./druzice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports